




















































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import AppSumoAssistant from '@/helpers/appsumo-assistant'

/* Data types */
import { AccountRoles } from '@/types/defined-types'
import {
  IAccountMembershipsInputCreate,
  IAccountMembershipsInputCreateInvitee,
} from '@/api/types/request.types'

/* API */
import AccountMembershipsAPI from '@/api/modules/account-memberships.api'
import { IItemForSelection } from '@/api/types/response.types'

export default Vue.extend({
  name: 'AddPeopleForm',

  props: {
    initialRows: {
      type: Number,
      default: 3,
    },
    maxRows: {
      type: Number,
      default: 10,
    },
    entityIdToAssign: {
      type: Number,
      default: null,
    },
    hideSuccessMessaging: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      AppSumoAssistant,
      isLoading: true,
      isSubmitting: false,
      AccountRoles,
      invalidEmailRows: [] as number[],
      validEmailRows: [] as number[],
      companies: [] as IItemForSelection[],
      formData: {
        sendInvitations: true,
        listInvitees: [] as IAccountMembershipsInputCreateInvitee[],
      } as IAccountMembershipsInputCreate,
    }
  },

  computed: {
    hasMultipleCompanies(): boolean {
      return this.companies.length > 1
    },
    lastInvitee(): IAccountMembershipsInputCreateInvitee {
      return this.formData.listInvitees[this.formData.listInvitees.length - 1]
    },
    isSingleInvite(): boolean {
      return this.maxRows === 1 && this.initialRows === 1
    },
    availableRoles(): IItemForSelection[] {
      return this.$permissions.availableRolesToAdmin
    },
    maxRowsReached(): boolean {
      return this.formData.listInvitees.length >= this.maxRows
    },
  },

  async created() {
    this.isLoading = true
    await this.getCreateOptions()
    this.resetFormData()
    this.isLoading = false
  },

  methods: {
    resetFormData() {
      let i
      this.formData.listInvitees = []
      for (i = 0; i < this.initialRows; i++) {
        this.formData.listInvitees.push({
          email: '',
          companyID: this.companies[0].id,
          accountRoleID: 1,
        })
      }
      if (this.entityIdToAssign) {
        this.formData.projectID = this.entityIdToAssign
      }
    },
    addRow(): void {
      /* Stub new row with blank email but carryover other columns */
      this.formData.listInvitees.push({
        email: '',
        accountRoleID: this.lastInvitee.accountRoleID,
        companyID: this.lastInvitee.companyID,
      })
    },
    addInvalidEmailIndex(index: number) {
      // Remove the index from the valid list...
      if (this.validEmailRows.includes(index)) {
        this.validEmailRows = this.validEmailRows.filter(e => e !== index)
      }

      // Add to the invalid list...
      if (this.invalidEmailRows.includes(index)) {
        return
      }
      this.invalidEmailRows.push(index)
    },
    addValidEmailIndex(index: number) {
      // Remove the index from the invalid list...
      if (this.invalidEmailRows.includes(index)) {
        this.invalidEmailRows = this.invalidEmailRows.filter(e => e !== index)
      }

      // Add to the valid list...
      if (this.validEmailRows.includes(index)) {
        return
      }
      this.validEmailRows.push(index)
    },
    async getCreateOptions() {
      try {
        const createOptions = await AccountMembershipsAPI.get_CreateOptions()
        this.companies = createOptions.listCompanies
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async createAccountMemberships() {
      /* Gotcha: For multi-invites, they may only have partial AM creations if they go over limit... */
      if (
        !(await AppSumoAssistant.isUnderAccountMembershipsLimit(
          this.$router,
          this.$permissions,
        ))
      ) {
        return
      }

      this.isSubmitting = true
      try {
        const response = await AccountMembershipsAPI.post_Create(this.formData)

        if (!this.hideSuccessMessaging) {
          this.$messaging.showSuccess(response.message)
        }
        this.resetFormData()
        this.$emit('account-memberships-created')
      } catch (error) {
        this.$error.emit(error, true)
      }
      this.isSubmitting = false
    },
  },
})
